package kz.dentalcrm.app.screens.diagnosis.list.mvi

import kz.dentalcrm.app.core.base.ViewEvent
import kz.dentalcrm.app.data.network.response_model.services.ServiceItem

sealed interface DiagnosisViewEvent : ViewEvent {

    data object AddServiceCategory : DiagnosisViewEvent

    data object Reload : DiagnosisViewEvent

    data class SearchService(
        val search: String
    ) : DiagnosisViewEvent

    data class EditService(
        val service: ServiceItem
    ): DiagnosisViewEvent

    data class DeleteDiagnosis(val id: Int) : DiagnosisViewEvent

    data object LoadMore : DiagnosisViewEvent
}